import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [res, setRes] = useState({ projects: [], services: [], blog: [] });

  useEffect(() => {
    const query = params.get("q") || "";
    if (query.length >= 2) api.get(`/search?q=${encodeURIComponent(query)}`).then((r) => setRes(r.data));
    else setRes({ projects: [], services: [], blog: [] });
  }, [params]);

  const submit = (e) => { e.preventDefault(); setParams({ q }); };

  return (
    <div data-testid="page-search" className="bg-[#F9F8F6] min-h-[80vh]">
      <section className="container-editorial pt-16 md:pt-24 pb-8 max-w-4xl">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">Search</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1]">Find a project, a service or a note.</h1>
        <form onSubmit={submit} className="mt-10 flex items-center gap-2 border-b-2 border-[#2B2927] pb-3">
          <SearchIcon size={20} />
          <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input" placeholder="Type to search…" className="flex-1 bg-transparent outline-none text-lg" autoFocus />
          <button type="submit" data-testid="search-submit" className="px-4 py-2 text-xs uppercase tracking-[0.2em]">Search</button>
        </form>
      </section>
      <section className="container-editorial pb-24 max-w-4xl space-y-12">
        {res.projects.length > 0 && <Group title="Projects">{res.projects.map((p) => (<Link key={p.id} to={`/portfolio/${p.slug}`} className="block py-4 border-b border-[#D5D0C8] hover:bg-[#F2EFE9]"><div className="font-serif text-2xl">{p.title}</div><div className="text-sm text-[#7A736C]">{p.location} · {p.year}</div></Link>))}</Group>}
        {res.services.length > 0 && <Group title="Services">{res.services.map((s) => (<Link key={s.id} to={`/services/${s.slug}`} className="block py-4 border-b border-[#D5D0C8] hover:bg-[#F2EFE9]"><div className="font-serif text-2xl">{s.title}</div><div className="text-sm text-[#7A736C]">{s.short_description}</div></Link>))}</Group>}
        {res.blog.length > 0 && <Group title="Journal">{res.blog.map((b) => (<Link key={b.id} to={`/blog/${b.slug}`} className="block py-4 border-b border-[#D5D0C8] hover:bg-[#F2EFE9]"><div className="font-serif text-2xl">{b.title}</div><div className="text-sm text-[#7A736C]">{b.excerpt}</div></Link>))}</Group>}
        {params.get("q") && res.projects.length + res.services.length + res.blog.length === 0 && <div className="text-[#7A736C]">No results found for "{params.get("q")}".</div>}
      </section>
    </div>
  );
}
function Group({ title, children }) {
  return <div><div className="text-[10px] uppercase tracking-[0.28em] text-[#A85C42] mb-3">{title}</div>{children}</div>;
}
